"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgHotPrice(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.97769 20.2972C2.29937 17.8887 2.63089 14.564 4.69829 12.5013L5.67566 11.5285C7.06765 10.1397 8.05918 8.37002 8.49008 6.42128C8.52801 6.25435 8.5584 6.08836 8.58878 5.92237C8.78834 4.74627 8.79412 3.58258 8.50824 2.51078C8.50824 2.51078 12.9568 2.84375 15.312 8.98474C16.1674 7.98363 15.5677 6.6505 14.9714 5.64131C16.5189 6.53534 26.5398 14.8612 14.4973 22.8605L13.2533 21.6102L15.1872 19.5176C15.3215 16.513 14.0158 13.9145 11.1846 12.3536C11.3592 12.8658 11.4501 14.4644 11.0736 15.4688C10.7318 16.3779 9.34778 17.4412 8.87953 18.2831C8.86386 18.3128 8.85149 18.338 8.83582 18.3677C8.25711 19.4765 8.40554 20.8464 9.17823 21.8256L10.6873 23.3415C7.33425 22.9821 5.66619 22.0716 4.74928 21.2014C4.71923 21.1735 4.69295 21.1452 4.6629 21.1173C4.41132 20.864 4.18055 20.5923 3.97769 20.2972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40337 11.2875C1.33596 13.3501 1.00444 16.6749 2.68276 19.0834C2.88563 19.3784 3.1164 19.6501 3.36798 19.9034C3.39803 19.9313 3.42431 19.9597 3.45436 19.9875C4.37127 20.8577 6.03932 21.7683 9.39236 22.1277L7.88331 20.6117C7.11062 19.6325 6.96219 18.2627 7.5409 17.1538C7.55657 17.1242 7.56893 17.0989 7.58461 17.0692C8.05286 16.2274 9.4369 15.164 9.77863 14.2549C10.1552 13.2505 10.0643 11.6519 9.88964 11.1398C13.7312 13.2576 14.7641 17.2857 13.2023 21.6466C25.2449 13.6473 15.224 5.32147 13.6765 4.42744C14.2728 5.43663 14.8725 6.76976 14.0171 7.77087C11.6619 1.62988 7.21332 1.29692 7.21332 1.29692C7.4992 2.36871 7.49342 3.53241 7.29386 4.7085C7.26347 4.87449 7.23309 5.04048 7.19516 5.20741C6.76425 7.15615 5.77273 8.92588 4.38073 10.3146L3.40337 11.2875Z",
    fill: "url(#paint0_linear_987_25005)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_987_25005",
    x1: "20",
    y1: "20.7993",
    x2: "17.3981",
    y2: "0.0215343",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    "stop-color": "#FF860C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    "stop-color": "#E5200E"
  }))));
}

var MemoSvgHotPrice = /*#__PURE__*/React.memo(SvgHotPrice);
var _default = MemoSvgHotPrice;
exports["default"] = _default;